import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Ulam Labs" link="https://www.ulam.io/" bg="linear-gradient(to right, rgb(0, 146, 69) 0%, rgb(252, 238, 33) 100%)" mdxType="ProjectCard">
  Developing and maintaining JAMstack website with Gatsby.js, Bootstrap and
  Netlify CMS.
    </ProjectCard>
    <ProjectCard title="Za Szkłem Fotografia" link="https://za-szklem-foto.vercel.app/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  Progressive web app created and designed from scratch to learn and master
  utility-first css library TailwindCSS and unit testing with Gatsby.js.
    </ProjectCard>
    <ProjectCard title="Upraisal" link="https://upraisal.io/" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
  10 week project of intensive work with Vue.js, Vuex and Buefy UI components.
  The MVP stage was created in SCRUM methodology.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      